<template>
  <div :class="['shelf', indexList == 0 ? 'shelf-top' : 'shelf-other']">
    <div
      v-for="(book, index) in bookList"
      :key="index"
      :class="[
        'book-shelf',
        indexList == 0 ? 'book-shelf-top' : 'book-shelf-other'
      ]"
    >
      <img
        :class="indexList == 0 ? 'book-img-top' : 'book-img-other'"
        :src="book.imageUrl"
        @click="handleChildClick(book.category)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["bookList", "indexList"],
  methods: {
    handleChildClick(categoryValue) {
      this.$emit("handleClick", categoryValue);
    }
  }
};
</script>

<style lang="css" scoped>
.book-img-top {
  height: 170px;
  width: 120px;
  object-fit: cover;
  margin: 10% 0;
}
.book-img-other {
  height: 170px;
  width: 120px;
  object-fit: cover;
  margin-top: 45%;
}
.shelf {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-size: cover;
}
.shelf-top {
  background-image: url("~@/assets/images/fanclub/leaders/bookshelf-top.png");
  height: auto;
}
.shelf-other {
  background-image: url("~@/assets/images/fanclub/leaders/bookshelf-board-top.png");
  justify-content: space-around;
  height: 230px;
}
.book-shelf {
  margin: auto;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/leaders/LeadersBook.vue